<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'
import Button from 'primevue/button'
import { usarSesion } from '@/stores/guion'
import { api, token } from '@/api/cliente'

const sesion = usarSesion()
const router = useRouter()
const oscuro = ref(localStorage.getItem('botia.oscuro') === '1')

function alternarTema() {
  oscuro.value = !oscuro.value
  document.documentElement.classList.toggle('oscuro', oscuro.value)
  localStorage.setItem('botia.oscuro', oscuro.value ? '1' : '0')
}

async function salir() {
  // Se revoca en el SERVIDOR antes de olvidarlo aquí. Borrarlo solo del
  // navegador deja el token vivo una semana entera para quien lo tenga copiado
  // de antes, que es justo de lo que uno se quiere proteger al pulsar "salir".
  //
  // Si la llamada falla igual se sale: dejar a alguien atrapado dentro porque
  // la red se cayó sería peor. Queda vivo hasta que caduque.
  try { await api.salir() } catch { /* se sale igual */ }
  token.olvidar()
  sesion.salir()
  router.push('/entrar')
}

onMounted(() => {
  document.documentElement.classList.toggle('oscuro', oscuro.value)
})
</script>

<template>
  <div class="app">
    <header v-if="sesion.autenticado" class="barra">
      <span class="marca">Guiones del bot</span>
      <Button label="Tenants" text size="small" icon="pi pi-list" @click="router.push('/')" />
      <!-- /api/acceso/usuarios exige botia-edit (PermisoEditar), y un líder no
           lo lleva global -es lo que cierra las rutas globales de plataforma-.
           Sin este v-if el botón siempre estuvo aquí porque hasta ahora todo el
           que entraba a la consola llevaba edit o pub; con botia-leader deja de
           ser cierto. -->
      <Button v-if="sesion.puedeEditar" label="Acceso" text size="small" icon="pi pi-users"
              @click="router.push('/usuarios')"
              v-tooltip.bottom="'Quién puede entrar a la consola y qué sesiones hay abiertas'" />
      <!-- Lo COMPARTIDO, al primer nivel. Publicar aquí mueve lo que heredarán
           varios clientes; colgarlo de uno haría pensar que el cambio es suyo.
           Catálogo y Capas se quedan SIN v-if: Task 8 abre sus lecturas a un
           líder con PuedeLeerConfig (edit O líder), así que el botón le sigue
           sirviendo. -->
      <Button label="Catálogo" text size="small" icon="pi pi-book" @click="router.push('/catalogo')"
              v-tooltip.bottom="'Qué sabe hacer la plataforma. Publicarlo no le cambia el bot a nadie hasta que lo adopten'" />
      <Button label="Capas" text size="small" icon="pi pi-clone" @click="router.push('/capas')"
              v-tooltip.bottom="'Las verticales e integraciones que heredan varios clientes'" />
      <!-- /api/plataforma/facturacion exige botia-edit tambien: mismo motivo
           que Acceso. -->
      <Button v-if="sesion.puedeEditar" label="Facturación" text size="small" icon="pi pi-wallet"
              @click="router.push('/facturacion')"
              v-tooltip.bottom="'Lo que consumió la IA en el periodo, con todos los clientes a la vez'" />
      <!-- Solo con botia-adm. Sin él la ruta contesta 403; enseñar el botón para
           que falle al pulsarlo es peor que no enseñarlo. -->
      <Button v-if="sesion.puedeAdmin" label="Auditoría" text size="small" icon="pi pi-history"
              @click="router.push('/auditoria')"
              v-tooltip.bottom="'Quién publicó, fijó, rotó o reveló qué, y cuándo'" />
      <span class="espacio" />
      <span class="tenue pequeno">{{ sesion.usuario?.nombre || sesion.usuario?.username }}</span>
      <!-- La versión del servidor, no la del navegador. Ya hubo dos veces en
           que "no me aparece X" resultó ser un binario sin actualizar y el
           código estaba bien; esto lo responde de un vistazo. -->
      <span v-if="sesion.usuario?.version" class="tenue pequeno mono"
            title="Versión del servidor que atiende esta consola">
        {{ sesion.usuario.version }}
      </span>
      <Button :icon="oscuro ? 'pi pi-sun' : 'pi pi-moon'" text rounded size="small"
              v-tooltip.bottom="'Cambiar tema'" @click="alternarTema" />
      <Button icon="pi pi-sign-out" text rounded size="small"
              v-tooltip.bottom="'Salir'" @click="salir" />
    </header>

    <main class="contenido">
      <RouterView />
    </main>

    <Toast position="bottom-right" />
    <ConfirmDialog />
  </div>
</template>
